<template>
  <div id="app" :style="{ height: height + 'px' }">
    <Header></Header>
    <div>
      <router-view />
    </div>
    <Footer></Footer>
    <!-- 联系方式浮窗 -->
    <div class="float-box" v-show="isShowFloat">
      <el-image @click="closeFloating" class="close-img" :src="require('@/assets/floatingWindow/close.png')"></el-image>
      <div class="box-content">
        <el-image :src="require('@/assets/floatingWindow/info.png')"></el-image>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      height: 0,
      isShowFloat: true
    }
  },
  watch: {
    $route(to, from) {
      this.isShowFloat = true
    }
  },
  created(){
  },
  mounted() {
    const _this = this
    let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    _this.height = clientHeight
    window.addEventListener('resize', () => {
      let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      _this.height = clientHeight
    }, false)
  },
  methods:{
    closeFloating(){
      this.isShowFloat = false
    }
  }
} 
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}
html,
body {
  padding: 0px;
  margin: 0px;
  min-width: 1400px;
  /* width: 1920px; */
}
ul li {
  list-style: none;
}
// 浮窗
.float-box {
  position: absolute;
  right: 56px;
  bottom: 30vh;
  z-index: 10;
  .box-content{
    width: 150px;
    height: 250px;
  }
  .close-img {
    position: absolute;
    top: 0;
    right: -23px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue